
import React, { Component, Fragment } from 'react';
import axios from '@/enhancers/axios';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import cookieManager from '../../../../utils/cookieManager';
import i18n from '../../../../i18n';
import DatePickerCustom from '../../../utilities/Form/datepicker';
import Select2 from "../../../utilities/Form/Select2";
import InputNumber from '../../../utilities/Form/InputNumber';
const token = cookieManager.getUserToken();
const MySwal = withReactContent(Swal);

export class UploadForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            form: {
                Upload: {},
            },
            dataDetail: [],
            idBranch: null,
            branchCurrent: null,
            branchText: i18n.t("Select Branch"),
            branchList: [],
            storeList: [],
            storeValue : null,
            storeText : i18n.t("Select Store"),
            warehouseList: [],
            warehouseValue : null,
            warehouseText : i18n.t("Select Warehouse"),
            coa3: null,
            coa3Current: null,
            coa3Text: i18n.t("Select COA 3"),
            coa3List: [],
            coa4: null,
            coa4Current: null,
            coa4Text: i18n.t("Select COA 4"),
            coa4List: [],
            message: null,
            file: null,
            date: new Date(),
            showDetail: false,
            loadingAccount: false,
            loadingCode: false,
            loadingCustomer: false,
            loadingSO: false,
            loadingPO: false,
            nominal: 0,
            loadingCode: false,
        }
        this.handler = this.handler.bind(this)
        this.handlerSelect = this.handlerSelect.bind(this)
        this.handlerDateTime = this.handlerDateTime.bind(this)
        this.runSubmit = this.runSubmit.bind(this)
    }

    runSubmit() {
        const Upload = {
            idBranch: this.state.branchCurrent != null ? this.state.branchCurrent.value : "",
            idStore: this.state.storeValue != null ? this.state.storeValue.value : "",
            idWarehouse: this.state.warehouseValue != null ? this.state.warehouseValue.value : "",
            file: this.state.file != null ? this.state.file : "",
            date: moment(this.state.date).format('YYYY-MM-DD'),
        }

        this.state.form.Upload = Upload;
        return this.state.form
    }

    handler(e) {
        var key = e.target.name;
        var value = e.target.value
        this.setState({
            [key]: value
        })
    }


    handlerCurrency(e, name) {
        var key = name;
        var value = e
        this.setState({
            [key]: value
        })
    }

    handlerSelect(e, name, currentState) {
        var key = name
        var value = null
        if (e != null) {
            value = e.value
        }
        this.setState({
            ...this.state,
            [key]: value
        })
        this.setState({ [currentState]: e })
    }

    renderError(name) {
        const { isError, errorMessage } = this.props
        var value = ''
        if (isError) {
            if (errorMessage[name] != undefined) {
                value = errorMessage[name][0]
            }
        }
        return i18n.t(value);
    }


    handlerDateTime(e, name) {
        var key = name;
        var value = e
        this.setState({
            [key]: value
        })
    }

    changeData({keyFill, type = null, key="", array = null, arraykey = null,callback=()=>{}}=props) {
        let params = null;
        switch (type) {
            case "getStore":
            var url = process.env.REST_URL + "helper/get-store";
            params = {
                branch: this.state.branchValue !=null?this.state.branchValue.value:null,
            };
            break;
            case "getWarehouse":
            var url = process.env.REST_URL + "helper/get-setup-warehouse-full";
            params = {
                branch: this.state.branchCurrent !=null?this.state.branchCurrent.value:null,
                store: this.state.storeValue !=null?this.state.storeValue.value:null,
            };
            break;
        }
        if (type != null) {
        axios({
            method: "GET",
            headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            },
            url: url,
            responseType: "json",
            params: params,
        })
            .then((response) => {
            if (response && response.status === 200 && response.data) {
                let dataResponse=null
                if (array != null) {
                var arr = [...this.state[array]];
                
                const objectss = arr[arraykey];
                if (key == "") {
                    dataResponse=response.data.result
                    objectss[keyFill] = response.data.result;
                } else {
                    dataResponse=response.data.result[key]
                    objectss[keyFill] = response.data.result[key];
                }
                } else {
                if (key == "") {
                    dataResponse=response.data.result
                    var arr = { [keyFill]: response.data.result };
                } else {
                    dataResponse=response.data.result[key]
                    var arr = { [keyFill]: response.data.result[key] };
                }
                }
                this.setState(arr, async () =>callback(dataResponse));
            }
            })
            .catch((error) => {
            console.log(error);
            });
        }
    }

    handleFileChange = (e) => {
        this.setState({ file: e.target.files[0] });
    }


    render() {
        const { helperBeginningBalance } = this.props
        if (helperBeginningBalance != null && helperBeginningBalance != '') {
            this.state.branchList = helperBeginningBalance.branch
            this.state.coa3List = helperBeginningBalance.coa3
            this.state.coa4List = helperBeginningBalance.coa4
        }

        return (
            <React.Fragment>
                <form>
                    <div className="row">
                        <div className="col-md-3 mt-3">
                            <DatePickerCustom
                                name={"date"}
                                title={i18n.t("Date")}
                                required={true}
                                selected={this.state.date}
                                onSelect={async (e) => {
                                    await this.handlerDateTime(e, 'date');
                                }}
                                disabled={this.state.isUpdate == 1 ? true : false}
                                onChange={(e) => { }}
                                startDay={0}
                                autoComplete={"off"}
                                dateFormat="dd MMMM yyyy"
                                showYearDropdown
                                yearDropdownItemNumber={15}
                                scrollableYearDropdown
                                peekNextMonth
                                showMonthDropdown
                                // minDate={this.state.cutOffDate}
                                maxDate={new Date()}
                                // minDate={this.state.limitDate}
                                className="form-control form-control-md"
                            />
                        </div>
                        <div className="col-md-3 mt-3">
                            <Select2
                                isClearable={true}
                                name={"idBranch"}
                                required={true}
                                size={4}
                                onChange={async (e) => {
                                    await this.handlerSelect(e, "idBranch", "branchCurrent");
                                    if(e!=null){
                                        await this.setState({loadingStore:true,loadingWarehouse:true})
                                        await this.changeData({
                                            keyFill:"storeList",
                                            type:"getStore",
                                            callback:()=>{this.setState({loadingStore:false})}
                                        })
                                        await this.changeData({
                                            keyFill:"warehouseList",
                                            type:"getWarehouse",
                                            callback:()=>{this.setState({loadingWarehouse:false})}
                                        })
                                    }else{
                                        await this.setState({
                                        warehouseList:[],
                                        storeList:[],
                                        warehouseValue:null,
                                        storeValue:null
                                        })
                                    }
                                }}
                                options={this.state.branchList}
                                title={i18n.t("Branch")}
                                value={this.state.branchCurrent}
                                placeholder={this.state.branchText}
                                labelfield={"true"}
                            />
                            <div className="fv-plugins-message-container invalid-feedback">
                                {this.renderError('BeginningBalance.idBranch')}
                            </div>
                        </div>
                        <div className="col-md-3 mt-3">
                            <Select2 
                                isClearable={true}
                                name={'idStore'}
                                className={""}
                                size={4}
                                isLoading={this.state.loadingStore}
                                onChange={async (e)=>{
                                    await this.handlerSelect(e,"idStore","storeValue")
                                    if(e !=null){
                                    await this.setState({warehouseValue:null,loadingWarehouse:true})
                                    await this.changeData({
                                        keyFill:"warehouseList",
                                        type:"getWarehouse",
                                        callback:()=>{this.setState({loadingWarehouse:false})}
                                    })
                                    }else{
                                    await this.changeData({
                                        keyFill:"warehouseList",
                                        type:"getWarehouse",
                                        callback:()=>{this.setState({loadingWarehouse:false})}
                                    })
                                    await this.setState({
                                        warehouseList:[],
                                        warehouseValue:null,
                                    })
                                    }
                                
                                }}
                                options={this.state.storeList}
                                title={i18n.t("Store")}
                                value={this.state.storeValue}
                                placeholder={this.state.storeText}
                                error={this.renderError('TakingGoods.idStore')}
                            />
                            </div>
                              <div className="col-md-3 mt-3">
                                <Select2 
                                    isClearable={true}
                                    name={'idWarehouse'}
                                    required={true}
                                    className={""}
                                    size={4}
                                    isLoading={this.state.loadingWarehouse}
                                    onChange={async(e)=>{
                                    if(this.state.warehouseValue !=e){
                                        await this.handlerSelect(e,"idWarehouse","warehouseValue")
                                        if(e !=null){
                                        await this.setState({loadingItem:true,arrayDetail:[ {
                                            itemValue:null,
                                            qty:0,
                                            description:'',
                                            convertionDetail:[]   
                                        }],itemList:[]})
                                        await this.changeData({
                                            keyFill:"itemList",
                                            type:"getItem",
                                            callback:()=>{this.setState({loadingItem:false})}
                                        })
                                        }else{
                                        this.setState({itemList:[],arrayDetail:[{
                                            itemValue:null,
                                            qty:0,
                                            description:'',
                                            convertionDetail:[]   
                                        }]})
                                        }
                                    }
                                    
                                    }
                                    }
                                    options={this.state.warehouseList}
                                    title={i18n.t("Warehouse")}
                                    value={this.state.warehouseValue}
                                    placeholder={this.state.warehouseText}
                                    error={this.renderError('TakingGoods.idWarehouse')}
                                />
                            </div>
                    </div>
                    <div className='row'>
                        <div className="col-md-6 mt-3">
                            <div>
                                <h2>{i18n.t("Upload File Excel")}</h2>
                                <input type="file" accept=".xlsx, .xls" onChange={this.handleFileChange} />
                                {/* <button type="submit">Upload</button> */}
                                {this.state.message && <p>{this.state.message}</p>}
                            </div>
                        </div>
                    </div>
                    <hr />
                </form>
            </React.Fragment>
        );
    }
}

export default UploadForm;